export default __webpack_public_path__ + "static/media/ss-seamless-forged-rings.3b93ce7d.webp";